import type {Permission} from '@hconnect/apiclient'

export const hasViewTechnicalKpisPermission = (permissions: Permission[]): boolean =>
  permissions.some((p) => p.permissionType === 'VIEW_TECHNICAL_KPIS')
